import AddressService from '@/services/address';

export default {
	namespaced: true,
	state: {
	},

	getters: {
    async getAddress() {
      let response;
      try {
        response = await AddressService.getAddress();
      } catch (e) {
        console.log(e)
      }
      return response;
    }
	},

	actions: {
		async createAddress({ commit, state, getters, dispatch }, payload) {
			let response
			try {
				response = await AddressService.createAddress({
					...payload
				});
			} catch (e) {
				console.log(e);
			}
			return response;
    },
    async updateAddress({ commit, state, getters, dispatch }, payload) {
      let response
			try {
				response = await AddressService.updateAddress({
					...payload
				});
			} catch (e) {
				console.log(e);
			}
			return response;
    },
    async deleteAddress({ commit, state, getters, dispatch }, id) {
      let response
			try {
				response = await AddressService.deleteAddress(id);
			} catch (e) {
				console.log(e);
			}
			return response;
    }
	},

	mutations: {
		// SET_VALUE_FROM_API(state, payload) {
		// 	state.valueFromApi = payload;
		// }
	}
};
